import PreviewMixin from '../mixins/preview-mixin'
import _ from '@/assets/lib/my-lodash'

export default {
  mixins: [PreviewMixin],
  props: {},
  data: function () {
    return {
      maxEduJobRows: 22,
      maxLicenseRows: 6,
      maxLicense4NewRows: 8,
      classObject: {
        introSummary: {},
        resumeSummary: {},
        entrySummary: {}
      },
      textareaMaxHeights: {
        introSummary: 60,
        resumeSummary: 90,
        entrySummary: 90
      },
      textMaxLength: {
        commuteDescription: 84
      },
      optionItems: {
        commuteDescription: true
      },
      errorMessages: {
        introSummary: '',
        resumeSummary: '',
        entrySummary: ''
      }
    }
  },
  computed: {
    formatedCreateDate: function () {
      if (!this.formatData || !this.formatData.createDate) {
        return '<span class="year">&nbsp;</span>年<span class="month">&nbsp;</span>月<span class="day">&nbsp;</span>日'
      } else {
        return this.$formLib.dateFormat(this.formatData.createDate, 'yyyy年 m月 d日')
      }
    }
  },
  methods: {
    adjustFontSize: function (refName) {
      this.classObject[refName] = {}
      this.errorMessages[refName] = ''
      this.$nextTick(function () {
        if (!this.$refs[refName]) return
        const maxHeight = this.textareaMaxHeights[refName]
        if (this.$refs[refName].clientHeight > maxHeight) {
          this.classObject[refName] = {
            'font-size-sm': true
          }
          console.error(refName)
        } else {
          this.classObject[refName] = {}
        }
        this.$nextTick(function () {
          if (this.$refs[refName].clientHeight > maxHeight) {
            this.errorMessages[refName] = '入力欄をオーバーしてます'
            this.classObject[refName] = { 'font-size-sm': true, error: true }
          }
        })
      })
    }
  },
  watch: {
    'formatData.introSummary': _.debounce(function () {
      this.adjustFontSize('introSummary')
    }, 500),
    'formatData.resumeSummary': _.debounce(function () {
      this.adjustFontSize('resumeSummary')
    }, 500),
    'formatData.entrySummary': _.debounce(function () {
      this.adjustFontSize('entrySummary')
    }, 500)
  }
}
